












































import {Component, Mixins, Watch, Prop, Ref} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import {Form, FormItem, Checkbox, Row, Col} from 'element-ui'
import VueNumeric from 'vue-numeric'

interface ConfirmOptions {
  message: string
  options: object
}

@Component({
  components: {
    [Row.name]: Row, [Col.name]: Col, BttPopup, VueNumeric,
    [Form.name]: Form, [FormItem.name]: FormItem, [Checkbox.name]: Checkbox,
  },
})
export default class TaxInputPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 0, type: Number}) taxValue: number
  @Prop({default: false, type: Boolean}) taxFreeValue: boolean
  @Prop({default: 0, type: Number}) computedTax: number
  @Prop({default: false, type: Boolean}) isMultiData: boolean

  @Ref('formRef') readonly formRef!: Form

  open: boolean = false
  tax: number = 0
  taxFree: boolean = false

  @Watch('value')
  __value(value) {
    this.open = value
    if(this.formRef) {
      this.formRef.resetFields()
      this.formRef.clearValidate()
    }
    if(value) {
      this.$nextTick(() => {
        this.tax = this.taxValue
        this.taxFree = this.taxFreeValue
      })
    }
  }

  onClickConfirm() {
    const data = {
      tax: this.taxFree ? 0 : this.tax,
      taxFree: this.taxFree,
    }
    this.$emit('set-tax', data)
    this.onHandlePopup(false)
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  confirmMessageOptions(taxFree): ConfirmOptions {
    const {ts} = this
    const taxFreeText = taxFree ? ts('tax-free') : ts('taxation')
    return {
      message: `모든 ${ts('item')}이 <span class="k-text-color-primary">"${taxFreeText}"</span> ${ts('item')}으로 변경됩니다. <br>
        (${ts('item')}은 모두 ${ts('tax-free')}이거나 ${ts('taxation')}여야 합니다.)`,
      options: {
        showClose: false,
        confirmButtonText: `${ts('change')}`,
        cancelButtonText: `${ts('cancel')}`,
        dangerouslyUseHTMLString: true,
      }
    }
  }

  onChangeTaxFree(value) {
    const confirmOptions = this.confirmMessageOptions(value)
    if(this.isMultiData) {
      this.$confirm(confirmOptions.message, confirmOptions.options)
        .then(() => {
          this.taxFree = value
          this.$emit('set-items-tax-free', value)
        })
        .catch(() => {
          this.taxFree = !value
        })
    } else {
      this.taxFree = value
    }
    if(!this.taxFree && this.tax === 0) {
      this.tax = this.computedTax
    }
  }
}
